import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ViewChildren, ElementRef, QueryList, ViewChild, HostListener } from '@angular/core';
import { InventoryCollectionEntity } from '../models/Inventory/InventoryCollectionEntity';
import { NavigationExtras } from '@angular/router';
import _ from 'lodash';
import { CommonService } from '../services/common.service';
import * as appApiResources from '../../shared/globalcontants';
import { Subscription } from 'rxjs';
import { InventoryService } from 'src/app/inventory/inventory.service';
import { IPageInfo } from 'ngx-virtual-scroller';
import { PurchaseOrderService } from 'src/app/purchase-order/purchase-order.service';
import { TransferService } from 'src/app/transfers/transfer.service';
import { SpoilageService } from 'src/app/spoilage/spoilage.service';
import { APIServiceProviderService } from '../services/APIServices/APIServiceProviderService/APIServiceProviderService';
import { GlobalConversionService } from '../services/GlobalMethodService/GlobalConversion-Service';
import { StatusLocationEntity } from '../models/Location/LocationEntity';
import { NgClass } from '@angular/common';
import { CheckboxComponent } from '../component/checkbox/checkbox.component';
import { NoItemsComponent } from '../no-items/no-items.component';
import { BottomPopOverComponent } from '../bottom-pop-over/bottom-pop-over.component';
import { TranslateModule } from '@ngx-translate/core';
import { DecimalFormatterPipe } from '../pipes/decimal-formatter.pipe';
@Component({
    selector: 'app-package-list-component',
    templateUrl: './package-list-component.component.html',
    styleUrls: ['./package-list-component.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, CheckboxComponent, NoItemsComponent, BottomPopOverComponent, TranslateModule, DecimalFormatterPipe]
})
export class PackageListComponentComponent implements OnInit {
  [x: string]: any;
  arrSelectedInventoryId: any = [];
  allCheckBox: any;
  allCBxDisable = false;
  @Input() Inputjson : any;
  @Input() bottomReached:any;
  totalCounts = 0;
  @Output() selectedItems: EventEmitter<any> = new EventEmitter();
  listJson: any = [];
  selectedInventory: any = [];
  baseUnitTypeId = 0;
  inventoryColection: InventoryCollectionEntity[] = [];
  @ViewChildren('rowParent') rowParent: QueryList<ElementRef>;
  @ViewChild('scrollcontainer') scrollcontainer;
  itemDynamicWidthCalc: Subscription;
  rowHeight = 0;
  LocationList: StatusLocationEntity;
  constructor(public _commonService: CommonService,public _is: InventoryService,public _eR: ElementRef,public _po: PurchaseOrderService,
    public _sp: SpoilageService,public _trans: TransferService, private apiServiceProviderService: APIServiceProviderService,private GlobalConService: GlobalConversionService) { }
  ngOnInit() {


    this.baseUnitTypeId = appApiResources.UnitType.BaseUnit;
  }

  addInArray(event, data, type) {
    let count = 0;

    if (type === 'all') {
      this.arrSelectedInventoryId = [];
      this.selectedInventory = [];
      if (event.target.checked) {
        for (const l of this.listJson) {
          l.selected = true;
          // this.arrSelectedInventoryId.push(l.InventoryOtherDetail.InventoryId);         
          this.arrSelectedInventoryId.push(l.Id);
          this.selectedInventory.push(l);
        }
      } else {
        for (const l of this.listJson) {
          l.selected = !l.selected;
        }
        this.selectedInventory = _.difference(this.selectedInventory, this.listJson);
        this.arrSelectedInventoryId = _.difference(this.arrSelectedInventoryId, this.listJson);
      }
    } else {
      data.selected = event.target.checked;
      for (let k = 0; k < this.arrSelectedInventoryId.length; k++) {
        // if (this.arrSelectedInventoryId[k] === data.InventoryOtherDetail.InventoryId) {
        if (this.arrSelectedInventoryId[k] ===  data.Id) {
          this.arrSelectedInventoryId.splice(k, 1);
          this.selectedInventory.splice(k, 1);
          count = 1;
        }
      }
      if (count === 0) {
        this.selectedInventory.push(data);
        // this.arrSelectedInventoryId.push(data.InventoryOtherDetail.InventoryId);
        this.arrSelectedInventoryId.push( data.Id);
      }
    }
    this.allCheckBox = (_.difference(this.listJson, this.selectedInventory).length === 0);
  }

  addInList() {
    const navigationExtras: NavigationExtras = {
        queryParams: {
          'selectedIds': this.arrSelectedInventoryId,
          'eventAction': 'selectedItemClick',
          'routedFrom': 'fromPackage'
        }
      };
      this.selectedItems.emit(navigationExtras);
    // this.router.navigate([this._is.reqrouteStack.pop()], navigationExtras);
  }

  closePopOver(event) {
    for (const c of this.listJson) {
      c.selected = false;
    }
    this.arrSelectedInventoryId = [];
    this.selectedInventory = [];
    this.allCheckBox = (_.difference(this.listJson, this.arrSelectedInventoryId).length === 0);
  }

  // tslint:disable-next-line: use-life-cycle-interface
  async ngOnChanges() {
    if (this.Inputjson) {
    if(this._commonService.isonlineStatus){
      let resultData =[];
        if(this.Inputjson.ResultData?.length > 0){
          const GetKey = Object.keys(this.Inputjson.ResultData)
          resultData = this.Inputjson.ResultData[0].Value as Array<any>;
        } 
        else {
          resultData = this.Inputjson.Data.ent.ResultData as Array<any>;
        }
        this.totalCounts = this.Inputjson.TotalCount;
        if(resultData?.length > 0){
          const inventoryId = resultData.map(x => x.Id);
          if (inventoryId?.length > 0) {
            this.LocationList = await this.apiServiceProviderService.setupService.GetInventoryStatusByLocation(inventoryId).toPromise();
          }
          if(this.inventoryColection?.length > 0){
            this.inventoryColection = [this.inventoryColection,...resultData];
          }
          else{
            this.inventoryColection = [...resultData];
          }
          resultData.forEach(data=>{
        const statusLocation = this.GlobalConService.statusByLocConversion(this.LocationList, data.IngredientId);
        const InventoryCollection = {} as InventoryCollectionEntity;
        InventoryCollection.Id = data.Id;
        InventoryCollection.Name = data.Name;
        InventoryCollection.Number = data.Number;
        InventoryCollection.QuantityonHandForAllLocs = statusLocation != null ? this.GlobalConService.customformatter(statusLocation.QOH) : 0;
        InventoryCollection.UnitsDetails = data.Units;
        InventoryCollection.BaseUnitCode = data.BaseUnitCode;
        InventoryCollection.InventoryId = data.IngredientId;
        this.listJson.push(InventoryCollection);
          })
        } 
      }     
      else{
        if (this.Inputjson.hasOwnProperty('Data') && this.Inputjson['Data'].length > 0) {
          this.Inputjson['Data'].forEach(data => {
            data.Id = data.Id || data.InventoryId;
            this.listJson.push(data);
          })
        }
        else {
          this.Inputjson?.forEach(data => {
            data.Id = data.Id || data.InventoryId;
            this.listJson.push(data);
          })
        }
           
        if(this.inventoryColection?.length > 0){
          this.inventoryColection = [this.inventoryColection,...this.listJson];
        }
        else{
          this.inventoryColection = [...this.listJson];
        }
      }   
      switch(this.bottomReached.id){
        case "requisition":
          if(this._is.InventotyLookupData.length>0)
            this._is.InventotyLookupData = [...this._is.InventotyLookupData,...this.inventoryColection];
          else
          this._is.InventotyLookupData = [...this.inventoryColection];
          break;
        case "Spoilage":
          if(this._sp.InventotyLookupData.length > 0)
            this._sp.InventotyLookupData = [...this._sp.InventotyLookupData,...this.inventoryColection];
          else
            this._sp.InventotyLookupData = [...this.inventoryColection];
          break;
        case "Transfer":
          if(this._trans.InventotyLookupData.length>0)
            this._trans.InventotyLookupData = [...this._trans.InventotyLookupData,...this.inventoryColection];
          else
            this._trans.InventotyLookupData = [...this.inventoryColection];
          break;
        case "PO":
          if(this._po.InventotyLookupData.length>0)
            this._po.InventotyLookupData = [...this._po.InventotyLookupData,...this.inventoryColection];
          else
            this._po.InventotyLookupData = [...this.inventoryColection];
          break;
      }         
    }      
    
    console.log('this.Inputjson', this.listJson);
    if (this.listJson && this.listJson.length > 0) {
      this._commonService.isFocusOut = true;
        this.showNodata = false;
        this.allCBxDisable = false;
      } else {
        this.listJson = [];
        this.showNodata = true;
        this.allCBxDisable = true;
    }    
  }
  // tslint:disable-next-line: use-life-cycle-interface
  ngAfterViewInit() {
    this.itemDynamicWidthCalc = this.rowParent.changes.subscribe(() => {
      const table = document.getElementsByClassName('list-row-parent') as HTMLCollectionOf<HTMLElement>;
      if (table) {
        const firstRow = table[0].getElementsByClassName('first-row') as HTMLCollectionOf<HTMLElement>;
        const price = table[0].getElementsByClassName('quantity') as HTMLCollectionOf<HTMLElement>;
        const name = table[0].getElementsByClassName('item-name') as HTMLCollectionOf<HTMLElement>;
        if (price.length > 0) {
          for (let itemList = 0; itemList < price.length; itemList++) {
            const firstRowWidth = firstRow[itemList].clientWidth;
            const pricewidth = price[itemList].clientWidth;
            (<HTMLElement>name[itemList]).style.width = ((firstRowWidth - 30) - pricewidth) + 'px';
          }
        }
      }
    });
}
// tslint:disable-next-line: use-life-cycle-interface
ngOnDestroy() {
  this.itemDynamicWidthCalc.unsubscribe();
  this._commonService.isFocusOut = false;
}

fetchMore(event) {   
  if(Math.round(event.target.offsetHeight + event.target.scrollTop) === event.target.scrollHeight)  
  {
    const totalTableCount = this._commonService.isonlineStatus ? this.Inputjson.Data.ent.TotalCount : (this.Inputjson.hasOwnProperty('TotalCount') ? parseInt(this.Inputjson['TotalCount']) : 2000);        
    if( this.listJson.length < totalTableCount ){      
      this.bottomReached.bottomReached(this.listJson.length)
   } 
  }
}
}
